import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';
import moment from 'moment-jalaali';
import Form from '../../Components/Boilerplates/Forms/Forms';
import Listview2 from '../../Components/Boilerplates/Listview/Listview2';

import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import DatePicker from 'react-datepicker2';
import { useDispatch, useSelector } from 'react-redux';
import ListS from '../../Components/UI/ListS/ListS';
import useHttp from '../../hooks/http';
import { showError } from '../../store';

const manageTypes = {
  Add: {
    type: 'form',
    inputs: [
      {
        id: 'aquifer_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد آبخوان',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
      {
        id: 'date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ',
        },
        value: moment(),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
      },
      {
        id: 'volume_change_mean',
        elementConfig: {
          type: 'text',
          placeholder: 'ميانگين تغيير حجم آبخوان (ميليون مترمكعب)',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
      },
    ],
    url: 'add/aquifer_detail/',
    title: 'افزودن اطلاعات آبخوان',
  },
  Upload: {
    type: 'form',
    inputs: [
      {
        id: 'aquifer_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد آبخوان',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
        queryParams: true,
      },
      {
        id: 'file',
        elementConfig: {
          type: 'file',
          accept: 'csv',
          placeholder: 'Hfile',
        },
        value: '',
        validation: {
          required: true,
        },
        valid: false,
        touched: true,
        single: true,
      },
    ],
    url: 'upload/aquifer_detail',
    title: 'آپلود اطلاعات آبخوان',
  },
  Get: {
    type: 'form',
    inputs: [
      {
        id: 'aquifer_id',
        elementConfig: {
          type: 'text',
          placeholder: 'کد آبخوان',
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true,
        },
        valid: false,
        touched: false,
        queryParams: true,
      },
      {
        id: 'start_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ شروع',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      },
      {
        id: 'end_date',
        elementConfig: {
          type: 'calendar',
          placeholder: 'تاریخ پایان',
        },
        value: moment(),
        requestValue: moment().format('YYYY-MM-DD'),
        validation: {
          required: true,
        },
        valid: true,
        touched: true,
        queryParams: true,
      },
    ],
    method: 'GET',
    notjson: true,
    handleResponse: (response) => {
      if (response.ok) {
        return response
          .blob()
          .then((data) => {
            const the = response.headers.get('Content-disposition');
            const thea = the.slice(the.indexOf('"') + 1, the.length - 1);

            return {
              blob: data,
              fileName: thea,
            };
          })
          .then(({ blob, fileName }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove(); //afterwards we remove the element again)
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    btnText: 'دریافت',
    url: 'download/admin/aquifer_detail',
    title: 'دریافت اطلاعات آبخوان',
  },
  List: {
    type: 'list',
    data: {
      id: 'aquifer_id',
      urlF: 'list_view/aquifer',
      urlS: 'list_view/aquifer_detail',
      list2: [{ en: 'volume_change_mean', fa: 'میانگین تغییر حجم آب' }],
    },
  },
};

const Aquifer = () => {
  const { type } = useParams();
  const thisPageData = useMemo(() => ({ ...manageTypes[type] }), [type]);
  const token = useSelector((state) => state.auth.Token);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const [codes, setCodes] = useState();

  useEffect(() => {
    sendRequest('get/aquifer/', 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      const the = [];

      data.forEach((element) => {
        the.push({ value: element.study_scope, gainValue: element.id });
      });

      setCodes({
        elementConfig: {
          type: 'select',
          placeholder: 'کد آبخوان',
          options: the,
        },
        indexValue: -1,
      });
      clear();
    }
  }, [error, isLoading, data, clear, setCodes]);

  const theReturn = useMemo(() => {
    switch (thisPageData.type) {
      case 'list':
        return <Listview {...thisPageData.data} />;
      case 'form':
      default:
        const theInputs = [...thisPageData.inputs];
        if (codes) {
          theInputs[0] = { ...theInputs[0], ...codes };
        }

        return (
          <Form
            {...thisPageData}
            inputs={theInputs}
            pageTitle={thisPageData.title ? thisPageData.title : ''}
            header={{ Authorization: `Bearer ${token}` }}
            btnStyle={{
              borderRadius: '25px',
              width: '100px',
              marginLeft: '2rem',
              fontWeight: 'bold',
            }}
          />
        );
    }
  }, [thisPageData, token, codes]);

  return theReturn;
};

export default Aquifer;

const Listview = (props) => {
  const [Conclude, setConclude] = useState();
  const [Stations, setStations] = useState();
  const [Range, setRange] = useState(1);
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  const ItemPerPage = useRef(10);
  const [dates, setDates] = useState(() => {
    const the = [];
    for (let i = 0; i < ItemPerPage.current; i++) {
      the.push([moment(), moment()]);
    }
    return the;
  });

  const { id, urlF, urlS, list2 } = props;

  useEffect(() => {
    sendRequest(urlF, 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token, urlF]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      setStations(data);

      clear();
    }
  }, [error, isLoading, data, clear, setMessage]);

  useEffect(() => {
    const ds = [];
    for (let i = 0; i < ItemPerPage.current; i++) {
      ds.push([moment(), moment()]);
    }
    setDates(ds);
  }, [Range, setDates]);

  const handleList = useCallback(
    (e, i) => {
      const start = moment(dates[i][0]).format('YYYY-MM-DD');
      const end = moment(dates[i][1]).format('YYYY-MM-DD');

      if (start >= end) {
        setMessage({ message: 'تاریخ را بدرستی انتخاب کنید', type: 'error' });
      } else {
        let url = `${urlS}?start_date=${start}&end_date=${end}&${id}=${e.id}`;
        console.log(url);
        setConclude({ url2: url, list2: list2 });
      }
    },
    [setConclude, dates, setMessage, id, list2, urlS]
  );

  const theStations = useMemo(() => {
    if (Stations) {
      const array = [];

      for (let i = (Range - 1) * ItemPerPage.current; i < Range * ItemPerPage.current && i < Stations.length; i++) {
        array.push(Stations[i]);
      }

      const setDS = (e, i, a) => {
        setDates((pre) => {
          const the = [...pre];
          const changed = [...pre[i]];
          changed[a] = e;
          the.splice(i, 1, changed);

          return the;
        });
      };

      return array.map((e, i) => (
        <ul key={e.study_scope}>
          <li>{e.study_scope}</li>
          <li className='DatePickerCustom'>
            <DatePicker
              showTodayButton={false}
              isGregorian={false}
              timePicker={false}
              persianDigits={false}
              value={dates[i][0]}
              onChange={(e) => setDS(e, i, 0)}
            />
          </li>
          <li className='DatePickerCustom'>
            <DatePicker
              showTodayButton={false}
              isGregorian={false}
              timePicker={false}
              persianDigits={false}
              value={dates[i][1]}
              onChange={(e) => setDS(e, i, 1)}
            />
          </li>
          <li>
            <span
              onClick={() => handleList(e, i)}
              style={{
                fontSize: '13px',
                border: '2px solid #00a18e',
                borderRadius: '25px',
                padding: '0 10px',
                cursor: 'pointer',
              }}
            >
              دریافت لیست
            </span>
          </li>
        </ul>
      ));
    }
  }, [Range, Stations, dates, setDates, handleList]);

  const PageRange = useMemo(() => {
    return (
      <div className='pageRange'>
        <div>صفحه قبل</div>
        <div>
          <div>
            <Icon size={1} path={mdiChevronLeft} onClick={() => setRange((pre) => (pre === 1 ? pre : pre - 1))} />
          </div>
          <div>{Range}</div>
          <div>
            <Icon
              size={1}
              path={mdiChevronRight}
              onClick={() => setRange((pre) => (Stations[Range * ItemPerPage.current] ? pre + 1 : pre))}
            />
          </div>
        </div>
        <div>صفحه بعد</div>
      </div>
    );
  }, [Range, setRange, Stations]);

  return Conclude ? (
    <Listview2 {...Conclude} />
  ) : (
    <ListS>
      <ul>
        <li>نام آبخوان</li>
        <li>تاریخ شروع</li>
        <li>تاریخ پایان</li>
        <li>لیست اطلاعات</li>
      </ul>
      {theStations}
      {PageRange}
    </ListS>
  );
};
